import React from 'react';
import { ColumnsType } from 'antd/es/table';

import { getTableSortOrder } from '../../common/getTableSortOrder';
import { InitialsBadgeTableCell } from '../../components/InitialsBadgeTableCell';

import { RemindersDataType } from './useRemindersTableDataSource';

// TODO: Add edit reminder page and unlock Link
const renderLinkCell = (text: string) => (
  // <Link to={`${PageRoutesEnum.reminderEdit}/${record.key}`} style={{ color: 'black' }}>
  <div style={{ width: '100%', padding: '16px' }}>{text}</div>
  // </Link>
);

// TODO: Add edit reminder page and unlock Link
const renderResponsibleLinkCell = (_text: string, record: RemindersDataType) => {
  return (
    // <Link to={`${PageRoutesEnum.reminderEdit}/${record.key}`} style={{ color: 'black' }}>
    <InitialsBadgeTableCell userName={record.user} />
    // </Link>
  );
};

export const useRemindersTableColumnDefinitions = ({
  sortedInfo,
  withLocalSorting,
}: {
  sortedInfo?: { field: string; order: string }[];
  withLocalSorting?: boolean;
}): ColumnsType<RemindersDataType> => {
  const remindersColumns = [
    {
      title: 'Title',
      dataIndex: 'title',
      sorter: withLocalSorting
        ? (a: RemindersDataType, b: RemindersDataType) => a.title.localeCompare(b.title)
        : {
            compare: () => 0,
            multiple: 1,
          },
      sortOrder: !withLocalSorting && sortedInfo ? getTableSortOrder(sortedInfo, 'title') : undefined,
      render: renderLinkCell,
      width: 140,
    },
    {
      title: 'Remind at',
      dataIndex: 'date',
      sorter: withLocalSorting
        ? (a: RemindersDataType, b: RemindersDataType) => a.date.localeCompare(b.date)
        : {
            compare: () => 0,
            multiple: 1,
          },
      sortOrder: !withLocalSorting && sortedInfo ? getTableSortOrder(sortedInfo, 'date') : undefined,
      render: renderLinkCell,
      width: 140,
    },
    {
      title: 'Type',
      dataIndex: 'type',
      sorter: withLocalSorting
        ? (a: RemindersDataType, b: RemindersDataType) => a.type.localeCompare(b.type)
        : {
            compare: () => 0,
            multiple: 1,
          },
      sortOrder: !withLocalSorting && sortedInfo ? getTableSortOrder(sortedInfo, 'type') : undefined,
      render: renderLinkCell,
      width: 140,
    },
    {
      title: 'Note',
      dataIndex: 'text',
      render: renderLinkCell,
      width: 140,
    },
    {
      title: 'Recipient',
      dataIndex: 'user',
      render: renderResponsibleLinkCell,
      width: 140,
    },
  ];

  return remindersColumns;
};
